<template>
    <div>
        <v-dialog
            v-model="dialogAddUser"
            persistent
            max-width="600px"
        >
            <template v-slot:activator="{ on, attrs }">
            <v-btn
                color="blue-grey"
                class="white--text mb-5 mt-5"
                v-bind="attrs"
                v-on="on"
                @click="obtenerUsuarios()"
            >
                Añadir usuarios
                <v-icon
                right
                dark
                >
                mdi-account-plus-outline
                </v-icon>
            </v-btn>
            </template>
            <v-card>
            <v-card-title>
                <span class="headline">Usuarios</span>
            </v-card-title>
            <v-card-text>
                <v-container>
                <v-row>
                    <v-col cols="12">
                    <v-autocomplete
                        :loading="loading"
                        :disabled="loading"
                        v-model="usuariosSeleccionados"
                        :items="usuariosNoGrupo"
                        filled
                        chips
                        color="blue-grey lighten-2"
                        label="Selecciona"
                        item-text="name"
                        item-value="name"
                        multiple
                        return-object
                    >
                        <template v-slot:selection="data">
                        <v-chip
                            v-bind="data.attrs"
                            :input-value="data.selected"
                            close
                            @click="data.select"
                            @click:close="eliminar(data.item)"
                        >
                            <v-avatar left :color="data.item.color">
                            <span class="white--text">{{ data.item.avatar }}</span>
                            </v-avatar>
                            {{ data.item.name }}
                        </v-chip>
                        </template>
                        <template v-slot:item="data">
                        <template v-if="typeof data.item !== 'object'">
                            <v-list-item-content v-text="data.item"></v-list-item-content>
                        </template>
                        <template v-else>
                            <v-list-item-avatar :color="data.item.color">
                                <span class="white--text">{{ data.item.avatar }}</span>
                            </v-list-item-avatar>
                            <v-list-item-content>
                                <v-list-item-title>{{ data.item.name }}</v-list-item-title>
                                <v-list-item-subtitle>{{ data.item.apellidos }}</v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                        </template>
                    </v-autocomplete>
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                text
                @click="dialogAddUser = false"
                >
                Cerrar
                </v-btn>
                <v-btn
                color="blue darken-1"
                text
                :disabled="this.$v.usuariosSeleccionados.$invalid"
                @click="addUsersToGroup()"
                >
                Añadir
                </v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import { mapState, mapActions } from 'vuex';
    import axios from 'axios';
    import { required } from 'vuelidate/lib/validators';
    axios.defaults.withCredentials = true;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;
    export default {
        name: 'DialogAddUsersToGroup',
        data () {
            return {
                loading: false,
                usuariosNoGrupo: [],
                usuariosSeleccionados: [],
                dialogAddUser: false,
            }
        },
        validations: {
            usuariosSeleccionados: { required }
        },
        methods: {
            ...mapActions(['setLoading', 'setSnackbar']),
            eliminar (item) {
                const index = this.usuariosSeleccionados.indexOf(item)
                if (index >= 0) this.usuariosSeleccionados.splice(index, 1)
            },
            obtenerUsuarios(){
                const usuariosDb = [];
                this.usuariosSeleccionados = [];
                this.loading = true;
                axios.get("/api/usuarios").then(respuesta => {
                    this.loading = false;
                    respuesta.data.forEach(usuario => {
                        usuariosDb.push(usuario);
                    });
                    // Comparamos el array de usuarios obtenidos de la base de datos con los usuarios actualmente vinculados al grupo
                    // y solo guardamos los usuarios de la base de datos que no están ya en el grupo
                    this.usuariosNoGrupo =  usuariosDb.filter(({ email: id1 }) => !this.grupo.user.some(({ email: id2 }) => id2 === id1));
                }).catch(error =>{
                    this.loading = false;
                    this.setSnackbar({
                        tipo: 'error',
                        mensaje: 'No se han podido recuperar los usuarios'
                    });
                });
            },
            addUsersToGroup(){
                console.log("Añadir usuarios a grupo");
                console.log(this.usuariosSeleccionados);
                this.usuariosSeleccionados.forEach(usuarioSeleccionado => {
                    this.grupo.user.push(usuarioSeleccionado);
                });
                this.dialogAddUser = false
            }
        },
        computed: {
            ...mapState('grupos', ['grupo'])
        }
    }
</script>